export const GoogleIcon = ({ className }: { className?: string }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M16.7625 9.18117C16.7625 8.64567 16.7186 8.10792 16.6264 7.58142H9.15637V10.6133H13.4336C13.3454 11.0985 13.1596 11.5607 12.8875 11.972C12.6154 12.3833 12.2627 12.7351 11.8507 13.0062V14.9749H14.4034C15.9019 13.6024 16.7625 11.5774 16.7625 9.18117Z"
      fill="#4285F4"
    />
    <path
      d="M9.15755 16.875C11.2928 16.875 13.0939 16.1775 14.4057 14.9738L11.8542 13.0061C11.1443 13.4865 10.2274 13.7588 9.1598 13.7588C7.0943 13.7588 5.34267 12.3728 4.7138 10.5098H2.0813V12.5381C2.7446 13.8445 3.75708 14.9414 5.00626 15.707C6.25545 16.4726 7.69242 16.8769 9.15755 16.875Z"
      fill="#34A853"
    />
    <path
      d="M4.7104 10.5098C4.37865 9.53218 4.37865 8.47243 4.7104 7.49481V5.46643H2.08015C1.52625 6.5628 1.23767 7.77396 1.23767 9.00231C1.23767 10.2306 1.52625 11.4418 2.08015 12.5382L4.7104 10.5098Z"
      fill="#FBBC04"
    />
    <path
      d="M9.15755 4.24121C10.2855 4.22292 11.3758 4.64693 12.195 5.42246L14.4563 3.17358C13.0192 1.8349 11.1214 1.10158 9.15755 1.12608C7.69202 1.12423 6.25469 1.52892 5.00543 2.29516C3.75617 3.06141 2.74393 4.15916 2.0813 5.46633L4.7093 7.49246C5.3348 5.62721 7.0898 4.24121 9.1553 4.24121H9.15755Z"
      fill="#EA4335"
    />
  </svg>
);
